import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {

  init({ state, dispatch }) {},

  fetchGroupingToList(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/APIv1/grouping/tolist/${query}`).then((response) => {
      const results = response.data
      return results
    })
  },

  fetchGrouping(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/APIv1/grouping/${query}`).then((response) => {
      return response.data
    })
  },

  createGrouping(context, formData) {
    let promise = null
    promise =  axios.post(`${serverUrl}/APIv1/grouping/`, formData)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  updateGrouping(context, {id, formData}) {
    let promise = null
    promise =  axios.put(`${serverUrl}/APIv1/grouping/${id}/`, formData)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },

  deleteGrouping(context, id) {
    let promise = null
    promise =  axios.delete(`${serverUrl}/APIv1/grouping/${id}/`)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  }

}

// ===
// Private helpers
// ===

function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}